import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { userRole } from '../store/actions/userActions';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const [userRoles, setUserRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const cookieToken = Cookies.get('tkn');
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const roles = await userRole();

                const normalized = Array.isArray(roles) ? roles : roles ? [roles] : [];
                setUserRoles(normalized);
            } catch (e) {
                console.error(e);
                setUserRoles([]);
            } finally {
                setLoading(false);
            }
        };

        if (cookieToken) fetchData();
        else setLoading(false);
    }, [cookieToken]);

    if (loading) {
        return (
            <Box sx={{ width: '100%' }} display='flex' justifyContent='center' alignItems={'center'}>
                Kraunama...
                <CircularProgress size={25} style={{ marginLeft: 10 }} />
            </Box>
        );
    }

    if (!cookieToken) {
        return <Navigate to='/login' state={{ from: location }} replace />;
    }

    if (!allowedRoles || allowedRoles.length === 0) {
        return children;
    }

    const hasAccess = allowedRoles.some((r) => userRoles.includes(r));

    return hasAccess ? children : <Navigate to='/not-authorized' replace />
};

// import { Navigate, useLocation } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import { useEffect, useState } from 'react';
// import { userRole } from '../store/actions/userActions';
// import { Box, CircularProgress } from '@mui/material';

// export const ProtectedRoute = ({ children, allowedRoles }) => {
//     const [userRoleName, setUserRoleName] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const cookieToken = Cookies.get('tkn');
//     const location = useLocation();
    
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const role = await userRole();
//                 setUserRoleName(role);
//                 setLoading(false);
//             } catch (e) {
//                 console.error(e);
//             }
//         };
    
//         if (cookieToken) fetchData();
//         else setLoading(false);
//     }, [cookieToken]);

//     if (loading) return <Box sx={{ width: '100%' }} display='flex' justifyContent='center'>
//                             Kraunama...
//                             <CircularProgress size={25} style={{ marginLeft: 10 }} />
//                         </Box>

//     if (cookieToken === undefined) {
//         return <Navigate to='/login' />;
//     } else {
//         if (allowedRoles.includes(userRoleName)) {
//             return children;
//         } else {
//             return <Navigate to='/not-authorized' />
//         }
//     }
// }